import DataTable from 'components/Core/DataTable';
import { MotionButton } from 'components/Core/MotionStrap';
import DefaultHeader from 'components/PurchaserFrontend/Headers/DefaultHeader';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import Purchaser from '../../lib/Core/Backend/Controllers/Purchaser';
import NotificationAlert from "react-notification-alert";
import { Button, Card, CardBody, CardTitle, CardHeader, Col, Container, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row, FormGroup, Input, Label} from 'reactstrap';
import Notify from 'lib/Utils/Alert';
import Utils from 'lib/Utils/Utils';
import ContactsCtl from 'components/PurchaserFrontend/Contacts/ContactsCtl';
import FromValidator from 'lib/Utils/FormValidator';
import Auth from '../../lib/Core/Backend/Controllers/Auth';
import Spinner from 'react-bootstrap/Spinner';
import ConfirmationAlertTwo from 'components/ConfirmationAlert/ConfirmationAlertTwo';
import RepresentativeUser from 'lib/Core/Backend/Controllers/RepresentativeUsers';
import PurchaserUsersManager from 'components/PurchaserFrontend/Users/PurchsaerUsersManager';
import dataTable from "../../assets/scss/react/dataTable.scss"
const mapKeys = {
  purchaserContactTypeId: 'contactTypeId',
  contactFirstName: 'contactFirstName',
  contactLastName: 'contactLastName',
  phone: 'contactPhone',
  email: 'contactEmail',
  mobile: 'contactMobile'
}

const PurchaserContacts = (props) => {
  const {purchaserId, token} = props;
  
  const purchaserCtl = useMemo(() => new Purchaser(token),[token]);
  const authCtl = useMemo(() => new Auth(token),[token]);
  const [contactsModal, setContactsModal] = useState(false);
  const [modal, setModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [showAlertMessage, setShowAlertMessage] = useState(false)

  const toggleContacts = () => setContactsModal(!contactsModal);
  const toggleDelete = () => setDeleteModal(!deleteModal);
  const toggleConfirm = () => setConfirmModal(!confirmModal);
  const toggle = () => setModal(!modal);
  const stayModal = () => setShowAlertMessage(false)

  const [contact, setContact] = useState(null);
  const [newPrimary, setNewPrimary] = useState(null);
  const [newContactType, setNewContactType] = useState(null);
  const [payload, setPayload] = useState({});
  const [activeOp, setActiveOp] = useState('Create new');
  const [activeContact, setActiveContact] = useState({});
  const [reload, setReload] = useState(false);
  const [loader,setLoader] = useState(true)
  const [addLoader,setAddLoader] = useState(false);
  const [editLoader,setEditLoader] = useState(false);
  const [confirmLoader,setConfirmLoader] = useState(false);
  const [primaryLoader,setPrimaryLoader] = useState(false);
  const triggerReload = () => setReload(!reload);


  
  const alert = useRef();
  const table = useRef();
  const primaryForm = useRef();
  const contactForm = useRef();
  const contactTypes = useRef();

   /* User Section */ 

    const representativeUsersClt = useMemo(() => new RepresentativeUser(token), [token]);
    const [modalTwo, setModalTwo] = useState(false);
    const [confirmModalUser, setConfirmModalUser] = useState(false);
    const [reloadTwo, setReloadTwo] = useState(false);
  
    const toggleUser = () => setModalTwo(!modalTwo);
    const toggleConfirmUser = () => setConfirmModalUser(!confirmModalUser);
    const triggerRelaod = () => setReload(!reload);
  
    const [activeOpUser, setActiveOpUser] = useState('Add new');
    const [contactUser, setContactUser] = useState(null);
    const [user, setUser] = useState(null);
  
    const [showAlertMessageUser, setShowAlertMessageUser] = useState(false)
    const [initialData, setInitialData] = useState({})
    const [loaderUser,setLoaderUser] = useState(true)
    const [addLoaderTwo,setAddLoaderTwo] = useState(false);
    const [editLoaderTwo,setEditLoaderTwo] = useState(false);
    const [addLoaderUser,setAddLoaderUser] = useState(false);
    const [editLoaderUser,setEditLoaderUser] = useState(false)
    const [apiUser, setApiUser] = useState(false);
    const [permissions, setPermissions] = useState(false);
    const [removeLoader,setRemoveLoader] = useState(false)
    const [numberOfContact,setNumberOfContact] = useState(null);
    

      const tableUser = useRef();
      const userForm = useRef();
      const contactSelect = useRef();

      const stayModalUser = () => setShowAlertMessageUser(false)
  
	const addLoaderFile = () =>{
    setTimeout(() => {
      setAddLoader(false);
    }, 1500);
  }
const editLoaderFile = () =>{
  setTimeout(() => {
    setEditLoader(false);
  }, 1500);
}


const groups = {
  purchaser: 'PURCHASER',
  representative: 'PURCHASER_REPRESENTATIVE',
  manager: 'PURCHASER_USER_MANAGER',
  apiUser: 'PURCHASER_API_CLIENT'
}


	const fetchPurchaserData = ()=> {
 
    purchaserCtl.purchaserCheck(purchaserId?`${purchaserId}`:0, (data) => {
 
      if (data && !data.error) {
        if(data?.users[0]?.enabled == false){
          sessionStorage.removeItem("accessToken")
            window.location.href="purchaser-auth/login"
    }
      }else{
       if((data?.errorMessage=="Purchaser not found"&& data?.errorCode=="BAD_REQUEST") || data?.errorMessage=="There is no records on the Purchaser brand limits table"){

          Notify(alert, 'danger', data?.errorMessage ?? data?.error);
              sessionStorage.removeItem("accessToken")
              window.location.href="purchaser-auth/login"
          }
          if((data?.errorMessage.includes("Username was not found") && data?.errorCode=="BAD_REQUEST") || data?.errorMessage=="There is no records on the Purchaser brand limits table"){
    
            Notify(alert, 'danger', data?.errorMessage ?? data?.error);
                sessionStorage.removeItem("accessToken")
                window.location.href="purchaser-auth/login"
            }
      }
})
    
  }

  const headerUser = [
    {title: 'Name', data: 'firstName', sortable: true, searchable: true, render: (data, type, row) => {
      if(data && row){
        return `${data} ${row.lastName}`
      } else {
        return 'Undefined';
      }
    }},
    {title: 'Email', data: 'username', sortable: true, searchable: true},
    {title: 'Permission level', data: 'groups', sortable: true, searchable: true, render: (data) => {
      if(data){
        if(data.includes(groups.manager, groups.purchaser, groups.representative)){
          return 'User Manager'
        } else {
          return 'Representative user'
        }
      }
      return 'Not found';
    }},
    {title: 'Active', data: 'enabled', sortable: true, searchable: true, render: (data) => {
      if(data)
        return 'Active';
      return 'Disabled';
    }},
  ]

  const prepareToEditUser = (row) => {
    setActiveOpUser('Edit');
    toggleUser();
    if(userForm.current){
      const rowData = row.data()
      const userData = {
        active: rowData.enabled,
        apiUser: rowData.groups.includes(groups.apiUser),
        permissions: rowData.groups.includes(groups.manager, groups.purchaser, groups.representative) ? true : false
      }

      setUser({ ...rowData });
      setApiUser(userData.apiUser);
      setPermissions(userData.permissions);

      userForm.current.active.checked = userData.active;
      // userForm.current.apiUser.checked = userData.apiUser;
      // userForm.current.permissions.checked = userData.permissions

      setInitialData({ ...userData })
    }
  };

   const confirmRemovalUser = (e) => {
      setRemoveLoader(true) 
      e.target.disabled = true;
      if(!!user){
        purchaserCtl.removeContact(purchaserId, user.contactId, (data) => {
         e.target.disabled = false;
         toggleConfirmUser()
            triggerRelaod();
          Notify(alert, 'danger', "User have been Removed");
          setTimeout(() => {
            setRemoveLoader(false)
          }, 1500);
        });
      } else {
        setTimeout(() => {
          setRemoveLoader(false)
        }, 1500);
        Notify(alert, 'danger', 'Something went wrong');
        toggleConfirmUser()
      }
    }

const finishOperationUser = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (userForm.current) {
      let newUser = {userGroups: [groups.purchaser]};

      if(activeOpUser === 'Add new'){
        if(apiUser === true){
          newUser.userGroups.push(groups.apiUser);
        }
        if(!contactUser){
          Notify(alert, 'danger', 'Select a contact');
          return
        }
      }

      switch (activeOpUser) {
        case 'Add new':
          setAddLoaderUser(true)
          newUser.firstName = contactUser.contactFirstName;
          newUser.lastName = contactUser.contactLastName;
          newUser.username = contactUser.email;
          newUser.phoneNumber = contactUser.phone;
          newUser.acceptPrivacyPolicy = true;
          newUser.acceptTermsAndConditions = true;
          purchaserCtl.addPurchaserUser(purchaserId, contactUser.id, newUser, data => {
            if(data && !data.error){
              let addToGroups = [];
              if(permissions === true && apiUser === false){
                addToGroups.push(groups.purchaser, groups.representative, groups.manager);
              }  
              if(apiUser === true && permissions === false) {
                addToGroups.push(groups.purchaser, groups.representative, groups.apiUser);
              }

              if(apiUser === true && permissions === true){
                addToGroups.push(groups.purchaser, groups.representative, groups.apiUser ,groups.manager);
              }

              if(permissions === false && apiUser === false){
                addToGroups.push(groups.purchaser, groups.representative);
              }
              representativeUsersClt.addUserToGroups(data.id, addToGroups, groupsData => {
                if(groupsData.error || groupsData.errorMessage){
                  setAddLoaderUser(false)
                  Notify(alert, 'danger', groupsData.errorMessage ?? groupsData.error);
                } else {
                  Notify(alert, 'success', 'Successfully created User');
                  setAddLoaderUser(false)
                  toggleUser();
                  triggerRelaod();
                }
              });
              
            } else {  
              Notify(alert, 'danger', data.errorMessage ?? data.error);
              setTimeout(() => {
                setAddLoaderUser(false)
               }, 1500);
            }
          });
        break;
        case 'Edit':
          setEditLoaderUser(true)
          if(!!user){
            newUser.firstName = user.firstName;
            newUser.lastName = user.lastName;
            newUser.username = user.username;
            newUser.phoneNumber = user.phoneNumber;
            newUser.id = user.id;
            newUser.reprentativeUser = true;
            newUser.enabled = userForm.current.active.checked
            representativeUsersClt.editUser(newUser, data => {
              if(data && !data.error){
                if(!newUser.userManager){
                  representativeUsersClt.removeUserFromGroups(data.id, [groups.manager, groups.apiUser], removeGroupsData => {
                    if(removeGroupsData.error || removeGroupsData.errorMessage){
                      Notify(alert, 'danger', data.errorMessage ?? data.error);
                      setEditLoaderUser(false);
                    } else {
                      let groupsToUpdate = [groups.purchaser, groups.representative]
                      userForm.current.apiUser.checked && groupsToUpdate.push(groups.apiUser)
                      userForm.current.permissions.checked && groupsToUpdate.push(groups.manager)
                      representativeUsersClt.addUserToGroups(data.id, groupsToUpdate, groupsData => {
                        if(groupsData.error || groupsData.errorMessage){
                          Notify(alert, 'danger', groupsData.errorMessage ?? groupsData.error);
                          setEditLoaderUser(false)
                        } else {
                          Notify(alert, 'success', 'Successfully edited user');
                          setEditLoaderUser(false)
                          toggleUser();
                          triggerRelaod();
                        }
                      });
                    }
                  });
                } else {
                  representativeUsersClt.addUserToGroups(data.id, [groups.representative, groups.purchaser, groups.manager], groupsData => {
                    if(groupsData.error || groupsData.errorMessage){
                      setEditLoaderUser(false)
                      Notify(alert, 'danger', groupsData.errorMessage ?? groupsData.error);
                    } else {
                      Notify(alert, 'success', 'Successfully created User');
                      setEditLoaderUser(false)
                      toggle();
                      triggerRelaod();
                    }
                  });
                }
              } else {
                Notify(alert, 'danger', data.errorMessage ?? data.error);
                setEditLoaderUser(false)
              }
            })
          } else {
            Notify(alert, 'danger', 'Something went wrong reload the page');
            setEditLoaderUser(false)
          }
        break;
        default:
        break;
      }
    }
  };

useEffect(()=>{    
 
fetchPurchaserData()

},[purchaserId])

  useEffect(() => {
    const handleGlobalKeyDown = (event) => {
      // If the space key is pressed, prevent its default action
      if (event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
      }
    };

    // Add the global event listener
    window.addEventListener('keydown', handleGlobalKeyDown);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('keydown', handleGlobalKeyDown);
    };
  }, []); // Empty dependency array ensures that the effect runs only once on mount


  const getUserData = () =>{
    purchaserCtl.users(purchaserId, (data) => {
      if(data.length === 0 ){
        setLoader(false)
      }
      if(data && !data.error){
        setLoader(false)
        if(tableUser.current){
          tableUser.current.dataTable.clear().rows.add(data).draw();
        }
      } else {
        Notify(alert, 'danger', data.errorMessage ?? data.error);
      }
    })
  }


  useEffect(() => {
      if(purchaserId){
        getUserData()
      }
      
    },[reload, purchaserId, purchaserCtl]);

  const changeContact = (row) => {
    let contactToEdit = table.current.dataTable.rows().data().toArray().find(contact => contact.purchaserContactTypeId === 1);
    if(!contactToEdit){
      Notify(alert, 'danger', 'No primary contact found');
      return;
    }
    setNewPrimary(row.data());
    setContactUser(`${contactToEdit.contactFirstName} ${contactToEdit.contactLastName}`)
    toggle();
    Utils.FillDropdown(primaryForm.current.contactSelect, contactTypes.current.filter(contactType => contactType.id !== 1), null, null, 'Select a contact Type...');
  };

  const updatePrimary = () => {
    if(primaryForm.current) {
      setPrimaryLoader(true)
      if(primaryForm.current.contactSelect.value === '-1') {
        Notify(alert, 'danger', 'select a contact');
        setTimeout(() => {
          setPrimaryLoader(false)
        }, 1500);
        return
      }
      setNewContactType(contactTypes.current.find(type => type.id === parseInt(primaryForm.current.contactSelect.value)));
      setPayload({
        purchaserId: purchaserId,
        contactId: newPrimary.id,
        contactTypeId: parseInt(primaryForm.current.contactSelect.value)
      });
      setTimeout(() => {
        setPrimaryLoader(false)
      }, 1500);
      toggleConfirm();
    }
  };

  const confirmOperation = () => {
    if(!!payload){
      purchaserCtl.setNewPrimary(payload.purchaserId, payload.contactId, payload.contactTypeId, (data) => {
        if(data && !data.error) {
          toggleConfirm();
          toggle();
          Notify(alert, 'info', 'Succesfully updated contact');
          triggerReload();
        } else{
          Notify(alert, 'danger', data.errorMessage ?? data.error);
        }
      });
    } else{
      Notify(alert, 'danger', 'Error in data');
      return
    }
  }

  const prepareForm = () => {
    if(contactForm.current){
      Utils.FillDropdown(contactForm.current.contactTypeId, contactTypes.current.filter(type => type.id !== 1), null, null, 'Select a type...')
      if(activeOp === 'Edit'){
        contactForm.current.contactEmail.disabled = true;
        if(activeContact.purchaserContactTypeId === 1){
          Utils.FillDropdown(contactForm.current.contactTypeId, contactTypes.current, null, null, 'Select a type...');
          contactForm.current.contactTypeId.disabled = true;
        }
        contactForm.current.contactTypeId.value = activeContact.purchaserContactTypeId.toString();
        contactForm.current.contactFirstName.value = activeContact.contactFirstName;
        contactForm.current.contactLastName.value = activeContact.contactLastName;
        contactForm.current.contactPhone.value = activeContact.phone;
        contactForm.current.contactMobile.value = activeContact.mobile;
        contactForm.current.contactEmail.value = activeContact.email;
        contactForm.current.contactId.value = activeContact.id;
        contactForm.current.userId.value = activeContact.userId ?? null;
        
        authCtl.checkIfUserExists(activeContact.email, data => {
          if(data.valueOf()){
            
            Notify(alert, 'info', 'This contact\'s address Email is associated to a User and cannot be edited');
          } else {
            contactForm.current.contactEmail.disabled = false;
          }
        });
      }
    }
  }

  const prepareToEdit = (row) => {
    setActiveOp('Edit');
    setActiveContact(row.data());
    toggleContacts();
  }

  const prepareToAdd = () => {
    setActiveOp('Create New');
    toggleContacts();
  }
  
  const prepareToAddUser = ()=>{
    setActiveOpUser("Add new")
    toggleUser()
    
  }

  const finishOperation = (e) => {
    e.target.disabled = true;
    if (!contactForm.current) return;

		const cv = new FromValidator(contactForm.current, (type, message) => Notify(alert, type, message),
			[
				{label: "", property: "id", input: "contactId", required: false},
        {label: "", property: "userId", input: "userId", required: false},
				{label: "Contact Type", property: "purchaserContactTypeId", input: "contactTypeId", required: true, noVal: "-1"},
				{label: "First Name", property: "contactFirstName", input: "contactFirstName", required: true},
				{label: "Last Name", property: "contactLastName", input: "contactLastName", required: true},
				{label: "Phone", property: "phone", input: "contactPhone", required: true, type: "phone"},
				{label: "Mobile", property: "mobile", input: "contactMobile", required: false, type: "phone"},
				{label: "Email", property: "email", input: "contactEmail", required: true, type: "email"}
			]
		);

		if (!cv.isFormValid())
			return e.target.disabled = false;
    
    const newContact = cv.getDTO();
    newContact.purchaserId = purchaserId;
    newContact.status = "new";
    newContact.userId = null;
    switch (activeOp) {
      case 'Create New':
        setAddLoader(true)
        authCtl.checkIfUserExists(newContact.email, (verificationData) => {
          if(!verificationData.valueOf()){
            purchaserCtl.addContact(purchaserId, newContact, (data) => {
              if(data && !data.error){
                addLoaderFile();
                toggleContacts();
                Notify(alert, 'success', 'Succesfully created contact');
                triggerReload();
              } else {
                Notify(alert, 'danger', data.errorMessage ?? data.error);
                addLoaderFile()
                e.target.disabled = false;
              }
            });
          } else {
            Notify(alert, 'danger', 'Email not Available');
            addLoaderFile();
            return e.target.disabled = false;
          }
        });
      break;
      case 'Edit':
        setEditLoader(true)
        if(contactForm.current.contactEmail.disabled){
          purchaserCtl.updateContact(purchaserId, newContact, data => {
            if(data && !data.error){
              editLoaderFile()
              toggleContacts();
              Notify(alert, 'success', 'Succesfully updated contact');
              triggerReload();
            } else {
              Notify(alert, 'danger', data.errorMessage ?? data.error);
              editLoaderFile();
              e.target.disabled = false;
            }
          });
        } else {
          authCtl.checkIfUserExists(newContact.email, verificationData => {
            if(!verificationData.valueOf()){
              purchaserCtl.updateContact(purchaserId, newContact, data => {
                if(data && !data.error){
                  toggleContacts();
                  editLoaderFile()
                  Notify(alert, 'success', 'Succesfully updated contact');
                  triggerReload();
                } else {
                  Notify(alert, 'danger', data.errorMessage ?? data.error);
                  editLoaderFile()
                  e.target.disabled = false;
                }
              });
            } else {
              Notify(alert, 'danger', 'Email not Available');
              editLoaderFile();
              return e.target.disabled = false;
            }
          });
        }
      break;
      default: break;
    }
  }

  const confirmDelete = () => {
    setConfirmLoader(true)
    if(purchaserId){
      purchaserCtl.removeContact(purchaserId, activeContact.data().id, data => {
        if(data.error || data.errorMessage){
          Notify(alert, 'danger', data.errorMessage ?? data.error)
          setTimeout(() => {
            setConfirmLoader(false)
          }, 1500);
        } else {
          setActiveContact(null);
          toggleDelete();
          triggerReload();
          Notify(alert, 'success', 'Contact succesfully deleted')
          setTimeout(() => {
            setConfirmLoader(false)
          }, 1500);
        }
      })
    }
  }

  const removeContact = (row) => {
    setActiveContact(row);
    toggleDelete();
  }

  useEffect(() => {
    purchaserCtl.contactTypes(data => {
      
      if(data && !data.error){
        contactTypes.current = data;
        if(!!purchaserId){
          purchaserCtl.contacts(purchaserId, contactData => {
            if(contactData.length === 0 ){
              setLoader(false)
            }
            if(contactData && !contactData.error){
              setLoader(false)
              if(table.current)
                table.current.dataTable.clear().rows.add(contactData).draw();
            } else {
              Notify(alert, 'danger', contactData.errorMessage ?? contactData.error);
            }
          });
        }
        
      } else {
        Notify(alert, 'danger', data.errorMessage ?? data.error);
      }
    })
  },[reload, purchaserCtl, purchaserId]);

  const handleModalClose = () => {
    if (activeOp === 'Add New') {
			let hasChanges = false
			contactForm.current.forEach(el => {
				if (!!el.value && el.value !== '-1') {
					hasChanges = true
				}
			})

			if (hasChanges) {
				setShowAlertMessage(true)
			} else {
				setContactsModal(false)
			}

		} else {
			const formHasChanges = modelChange(activeContact, contactForm.current)
			if (formHasChanges){
				setShowAlertMessage(true)
			} else {
				setContactsModal(!contactsModal)
			}
		}
  }

  const leaveAllModal = () => {
		setShowAlertMessage(false)
		setContactsModal(false)
	}

  const modelChange = (initial, endModel) => {
		let changed = false
		Object.entries(initial).forEach(([key, value]) => {
			if (endModel[mapKeys[key]] && value !== endModel[mapKeys[key]].value) {
				changed = true
				return
			}
		})
		return changed
	}


  return (
    <>
    <div className='mt-5 pt-5' style={{backgroundColor:"rgb(232, 237, 251)"}}>
      {/* <DefaultHeader /> */}
      <ConfirmationAlertTwo stayModal={stayModal} openModal={showAlertMessage} leaveModal={leaveAllModal} />
      <NotificationAlert ref={alert}/>
      {/* Contact section */}
      <Container className="mt--5" fluid>
        <Row >
          <Col md={12}>
            <Card className="shadow">
              <CardHeader className="d-sm-flex justify-content-between">
                <CardTitle tag="h1">Contact list</CardTitle>
                <MotionButton className="py-2 motion_color" style={{height:'40px',color:'white'}} initial={{ x: "-500%", opacity: 0 }} animate={{ x: 0, opacity: 1, transition: { delay: 0.4, duration: 0.5 } }}  onClick={prepareToAdd}>
                  <i className="fas fa-user"  style={{color:"white"}}/>{' '}Create new Contact
                </MotionButton>
              </CardHeader>
              <CardBody >
                {loader ?
                  <div className='d-flex justify-content-center align-items-center flex-column vh-50'>
								   <div className="spinner-border text-muted text-center"></div>
								</div>
                :
                
                <div className="table-responsive P-2">
                <DataTable
                  ref={table}
                  columns={[
                    {title: 'Name', data: 'contactFirstName', sortable: true, searchable: true, render: (data, type, row) => {
                      if(data)
                        return `${Utils.deleteTags(data)} ${Utils.deleteTags(row.contactLastName)}`;
                      return 'Undefined';
                    }},
                    {title: 'Email', data: 'email', sortable: true, searchable: true},
                    {title: 'Phone Number', data: 'phone', sortable: true, searchable: true},
                    {title: 'Contact Type', data: 'purchaserContactTypeId', sortable: true, searchable: true, render: (data) => {
                      let contactType = contactTypes.current.find(type => type.id === data);
                      if(contactType)
                        return contactType.name;
                      return 'Undefined';
                    }},
                    {title: '', data: 'purchaserContactTypeId', render: (data) =>{
                      if(data !== 1)
                        return `<button class="btn btn-primaryTwo py-0 ncentiva-setPrimary-btn">Set as pimary</button>`;
                      return '';
                    }}
                  ]}
                  className="j_add_order_table j_table_data_design"
                  data={null}
                  options={{
                    saveState: false,
                    scrollCollapse: true,
                    order: [[0, "desc"]],
									  dom: 'tip',
                    language: { "paginate": { "next": "<i class='fas fa-angle-right'></i>", "previous": "<i class='fas fa-angle-left'></i>" } },
                  }}
                  addEditButtonTwo={{callback: prepareToEdit}}
                  addRemoveButton={{callback: removeContact}}
                  //disableAllMail={{callback: removeContact}}
                  addBtnsFromData={[{callback: changeContact, selector: 'button.ncentiva-setPrimary-btn'}]}
                />
                </div>
}
              </CardBody>
              {/* <CardFooter >
                <Row className="justify-content-end">
                  <Col md="auto">
                    <MotionButton initial={{x: "-500%", opacity: 0}} animate={{x: 0, opacity: 1, transition: {delay: 0.4, duration: 0.5}}} color="primary" onClick={prepareToAdd}>
                      <i className="fas fa-user"/>{' '}Create new Contact
                    </MotionButton>
                  </Col>
                </Row>
              </CardFooter> */}
            </Card>
          </Col>
        </Row>
      </Container>
         {/* user section */}
      <Container className="mt-5" fluid>
        <Row >
          <Col md={12}>
            <Card className="shadow">
              <CardHeader className="d-flex justify-content-between">
                <CardTitle tag="h1" className='mb-0'>Users list</CardTitle>
                <MotionButton className="py-2 motion_color" style={{color:"white"}} initial={{ x: "-500%", opacity: 0 }} animate={{ x: 0, opacity: 1, transition: { delay: 0.4, duration: 0.5 } }}  onClick={prepareToAddUser}>
                  <i className="fas fa-user"style={{color:"white"}} />{' '}Create new User
                </MotionButton>
              </CardHeader>
              <CardBody >
              {loader ? 
                <div className='d-flex justify-content-center align-items-center flex-column vh-50'>
								   <div className="spinner-border text-muted text-center"></div>
								</div>
                :
                <div className="table-responsive">
                <DataTable
                  ref={tableUser}
                  data={null}
                  className="j_add_order_table j_table_data_design"
                  options={{
                    saveState: false,
                    scrollY: '100px',
									  scrollCollapse: true,
                    order: [[0, "desc"]],
									  dom: 'tip',
                    language: { "paginate": { "next": "<i class='fas fa-angle-right'></i>", "previous": "<i class='fas fa-angle-left'></i>" } },
                  }}
                  columns={headerUser}
                  addEditButtonTwo={{callback: prepareToEditUser}}
                  addRemoveButton={{callback: (row) => {
                    setUser(row.data());
                    toggleConfirmUser();
                  }}}

                />
                </div>
               }
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal isOpen={modalTwo} toggle={toggleUser} backdrop="static" centered={true} size="md">
          <ModalHeader toggle={toggleUser} className='custom_header_colourTwo d-flex align-items-center justify-content-between'>{activeOpUser} User</ModalHeader>
          <ModalBody>
            <Form innerRef={userForm}>
              <PurchaserUsersManager activeOp={activeOpUser} purchaserId={purchaserId} contactSelect={contactSelect} setContact={setContactUser} token={token} 
              apiUser={apiUser}  setApiUser={setApiUser} permissions={permissions} setPermissions={setPermissions} numberOfContact={numberOfContact}  setNumberOfContact={setNumberOfContact} />
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary" onClick={toggleUser}>Cancel</Button>
            <Button type="button" className='btn btn-primaryTwo' onClick={finishOperationUser} disabled={addLoaderUser || editLoaderUser}>Save{
              addLoaderUser || editLoaderUser &&
                <Spinner
										as="span"
										animation="border"
										size="sm"
										role="status"
										aria-hidden="true"
										style={{
										margin: "0px 8px"
										}}
									/>
            }</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={confirmModalUser} toggle={toggleConfirmUser} centered={true} backdrop="static">
				<ModalHeader className="custom_header_colourTwo align-items-center" toggle={toggleConfirmUser}>
          <h3 className='mb-0 ' style={{fontSize:'20px',color:"white"}}>Remove User</h3>
        </ModalHeader>
				<ModalBody>
					<p className="card-just-text">
						Are you sure you want to remove the user "{!!user  ? `${user.firstName} ${user.lastName}` : ""}"?
					</p>
				</ModalBody>
				<ModalFooter>
					<Button color="secondary" onClick={toggleConfirmUser}>Cancel</Button>
					<Button className='btn btn-primaryTwo' onClick={confirmRemovalUser} disabled={removeLoader}>{!removeLoader && "Yes"}{
            removeLoader && 
            <Spinner
										as="span"
										animation="border"
										size="sm"
										role="status"
										aria-hidden="true"
										style={{
										margin: "0px 8px"
										}}
									/>
            }</Button>
				</ModalFooter>
			</Modal>
      </Container>

      <Modal isOpen={modal} toggle={toggle} backdrop="static" centered={true} size="md">
          <ModalHeader toggle={toggle} className=' custom_header_colourTwo'></ModalHeader>
          <ModalBody>
            <Form innerRef={primaryForm}>
              <Row form className='justify-content-center text-center'>
                <Col md={8}>
                  <FormGroup>
                    <Label for="contactSelect">Select new Contact Type for {contactUser}</Label>
                    <Input type="select" name="contactSelect" id="contactSelect" >
                      <option value="-1">Select a contact type</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary"  onClick={toggle}>Cancel</Button>
            <Button type="button" className='btn btn-primaryTwo' onClick={updatePrimary} disabled={primaryLoader}>{!primaryLoader && "Save"}{ 
            primaryLoader &&
            <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            style={{
            margin: "0px 8px"
            }}
          />
       }</Button>
          </ModalFooter>
      </Modal>

      <Modal isOpen={confirmModal} toggle={toggleConfirm} backdrop="static" centered={true} size='sm'>
				<ModalHeader className="custom_header_colourTwo" toggle={toggleConfirm}>Change contacts</ModalHeader>
				<ModalBody>
					<p className="card-just-text">
						Are you sure you want to set contact "{!!newPrimary ? `${newPrimary.contactFirstName} ${newPrimary.contactLastName}` : ""}" as Primary contact
            and "{!!contactUser ? contactUser : ""}" as {!!newContactType ? newContactType.name : ""}?
					</p>
				</ModalBody>
				<ModalFooter>
					<Button type="button" color="secondary" onClick={toggleConfirm}>Cancel</Button>{' '}
					<Button type="button" className='btn btn-primaryTwo' onClick={confirmOperation}>Yes</Button>
				</ModalFooter>
			</Modal>

      <Modal isOpen={contactsModal} toggle={toggleContacts} backdrop="static" centered={true} size="md" onOpened={prepareForm}>
        <ModalHeader toggle={handleModalClose} className='custom_header_colourTwo'>{activeOp} contact</ModalHeader>
        <ModalBody>
          <ContactsCtl formRef={contactForm} />
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" onClick={handleModalClose}>Cancel</Button>
          <Button type="button" className='btn btn-primaryTwo' onClick={finishOperation} disabled={addLoader || editLoader}>Save{
            addLoader || editLoader &&
                   <Spinner
										as="span"
										animation="border"
										size="sm"
										role="status"
										aria-hidden="true"
										style={{
										margin: "0px 8px"
										}}
									/>
            }</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={deleteModal} toggle={toggleDelete} backdrop="static" centered={true}>
				<ModalHeader className="custom_header_colourTwo align-items-center" toggle={toggleDelete}>
          <h3 className='mb-0' style={{fontSize:'20px',color:"white"}}>Remove Purchaser</h3>
        </ModalHeader>
				<ModalBody>
					<p className="card-just-text">
						Are you sure you want to remove the Contact "{!!activeContact && !!activeContact.data ? `${activeContact.data().contactFirstName} ${activeContact.data().contactLastName}` : ""}"?
					</p>
				</ModalBody>
				<ModalFooter>
					<Button type="button" color="secondary" onClick={toggleDelete}>Cancel</Button>{' '}
					<Button type="button" className='btn btn-primaryTwo' onClick={confirmDelete} disabled={confirmLoader}>{!confirmLoader && "Yes"}{
            confirmLoader &&
                  <Spinner
										as="span"
										animation="border"
										size="sm"
										role="status"
										aria-hidden="true"
										style={{
										margin: "0px 8px"
										}}
									/>
       }</Button>
				</ModalFooter>
			</Modal>
   
      </div>
    </>
  );
}
 
export default PurchaserContacts;